import React  from 'react';
import FormField from "./FormField";
import { Validators } from "Utils/Constants";
import DatePicker from 'react-datepicker';

/**
 *
 * @param {DateField.defaultProps} props
 * @returns
 */
const DateField = (props) => {
  return (
    <FormField {...props} />
  );
}

DateField.defaultProps = {
  ...FormField.defaultProps,
  // Must be over 18
  validators: [Validators.AGE_18],
  placeholder: 'MM/DD/YYYY',
  renderControl: (props, showError, fieldValue, onChange) =>
    <DatePicker
      id={props.fieldName}
      name={props.fieldName}
      className={showError ? "form-control calendar is-invalid" : "form-control calendar"}
      dateFormat={props.dateFormat || "MM/dd/yyyy"}
      showMonthDropdown
      showYearDropdown
      selected={fieldValue}
      placeholderText={props.placeholder}
      onChange={onChange}
      onBlur={_ => onChange(fieldValue)}
      disabled={props.disabled}
      showMonthYearPicker={props.showMonthYearPicker || undefined}
      showFullMonthYearPicker={props.showFullMonthYearPicker || undefined}
      showTwoColumnMonthYearPicker={props.showTwoColumnMonthYearPicker || undefined}
    />
};

export default DateField;